/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoogleRegularAi from './google-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoogleRegularAi {...validProps} />;
}
SvgComponent.iconName = 'googleRegularAi';

export const GoogleRegularAiIcon = svgIconWrapper(SvgComponent);
